import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./hero.css";
import image1 from "../Assets/hero2.jpeg";
// import image2 from "../Assets/plant-picture-clean-room-equipment-stainless-steel-machines.jpg";
//  import image3  from "../Assets/plant-picture-clean-room-equipment-stainless-steel-machines1.jpg";
//  import image3  from "../Assets/hero3.jpeg";


const Hero = () => {
  const images = [image1,];
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false, useCSS: true,
  };

  return (
    <div className="container-fluid p-0">
      {/* <Slider {...settings}>
        {images.map((src, index) => (
          <div key={index}>
            <img src={src} className="w-100 slide-img" alt={`Slide ${index}`} loading="lazy" />
          </div>
        ))}
      </Slider> */}
        <div >
            <img src={image1} className="w-100 slide-img" alt={`Slide Img`} loading="lazy" />
          </div>
    </div>
  );
};

export default Hero;
